import { EVOLVE_IMAGE_SRC_REGEX } from 'utils/imageLoaders/evolveImageLoader'

const getListingCloudinaryId = (url: string) => {
  if (EVOLVE_IMAGE_SRC_REGEX.test(url)) {
    return url
  }

  const file = 'listings_s3/' + url.split('listings_s3').pop()
  return file
}

export default getListingCloudinaryId
